import * as React from 'react';
import { CenterAlignedRow } from 'components/Styled/Layout/CenterAlignedRow';
import { Col, Form, Input, Row, Button, Select } from 'antd';
import FormControl from 'components/Forms/FormControl';
import { FormComponentProps } from 'antd/lib/form';
import { withRouter, RouteComponentProps, NavLink } from 'react-router-dom';
import ValidationUtility from 'Core/ValidationUtility';
import { IChangePasswordCommandRequest, SecurityQuestionModel, IUpdateSecurityQuestionsCommandRequest, SecurityQuestion, UpdateSecurityQuestionsCommandRequest } from 'Core/Api/Api';
import FormItem from 'antd/lib/form/FormItem';
import NotificationService from 'Core/NotificationService';
import ConfigService from 'Core/ConfigService';
import Title from 'antd/lib/typography/Title';
import SimpleSelect from '../../Forms/SimpleSelect';
import ISelectOption from '../../Forms/SimpleSelect/ISelectOption';
import UserProfileHandler from '../UserProfileHandler';

const { Option } = Select;

export interface Props extends FormComponentProps, RouteComponentProps {
    children?: React.ReactNode;
}

export interface State {
    emailAddress?: string;
    questions: ISelectOption[];
    question1?: SecurityQuestionModel;
    question2?: SecurityQuestionModel;
    question3?: SecurityQuestionModel;
}

export class UpdateSecurityQuestionFormWithoutFormsAndRouter extends React.Component<Props, State> {
    handler: UserProfileHandler;

    constructor(props: Props) {
        super(props);

        this.state = { questions: [] };
        this.handler = new UserProfileHandler(props);
    }

    componentDidMount() {
        this.setSecurityQuestions();
        this.retrieveSecurityQuestions();

    }


    retrieveSecurityQuestions() {
        this.handler.GetSecurityQuestions().then((x) => {
            if (x.questions) {
                this.setState({ question1: x.questions[0] });
                this.setState({ question2: x.questions[1] });
                this.setState({ question3: x.questions[2] });

                var data = {
                    question1: this.state.question1?.question,
                    question2: this.state.question2?.question,
                    question3: this.state.question3?.question
                };


                this.props.form.setFieldsValue(data ?? {});

            }


            //for (var i = 0; i < (x.questions?.length ?? 0); i++) {
            //    if (i == 0) {

            //    }
            //}
        });

    };

    setSecurityQuestions() {
        var questions = [
            { text: 'What is the name of your childhood best friend?' },
            { text: 'What is the name of your manager at your first job?' },
            { text: 'Who is your favourite author?' },
            { text: 'What was the name of your first pet?' },
            { text: 'Where did you meet your spouse?' },
            { text: 'What is the name of the hospital in which you were born?' },
            { text: "What is your mother's middle name?" },
            { text: 'What was your favourite restaurant in college?' },
            { text: 'What was your favourite food as a child?' },
            { text: 'What is the name of your favourite book?' },
            { text: 'What is the first name of your favourite aunt?' },
            { text: 'What was your dream job as a child?' },
            { text: 'What was the name of your first school?' },
            { text: 'What is the first name of your oldest niece?' },
            { text: 'Where did you spend your honeymoon?' }
        ];
        this.setState({ questions: questions });

        //<Select mode="tags" style={{ width: '100%' }} tokenSeparators={[',']}>
        //    {this.state.questions?.map((value, index) => {
        //        return <Option key={value.text?.toString()}>{value.text}</Option>
        //    })}
        //</Select>
    }

    onSubmit = (e: React.SyntheticEvent) => {
        e.preventDefault();
        this.props.form.validateFields((error, values: any) => {
            if (error) {
                return;
            }


            var data: SecurityQuestionModel[] = [];

            var question1 = new SecurityQuestionModel();
            question1.question = values.question1;
            question1.answer = values.answer1;
            question1.id = this.state.question1?.id;
            data.push(question1);

            var question2 = new SecurityQuestionModel();
            question2.question = values.question2;
            question2.answer = values.answer2;
            question2.id = this.state.question2?.id;
            data.push(question2);

            var question3 = new SecurityQuestionModel();
            question3.question = values.question3;
            question3.answer = values.answer3;
            question3.id = this.state.question3?.id;
            data.push(question3);

            var request = new UpdateSecurityQuestionsCommandRequest();
            request.questions = data;

            this.handler.UpdateSecurityQuestions(request).then(() => {
                this.props.history.goBack();
                NotificationService.success('Password has been updated');
            });
        });
    };

    render() {
        var { getFieldDecorator } = this.props.form;
        var passwordValidations = ValidationUtility.password;
        var compareValidations = ValidationUtility.compare;


        return (
            <Row>
                <Col>
                    <Form onSubmit={this.onSubmit}>
                        <Title>Update Security Questions </Title>

                        <FormControl
                            getFieldDecorator={getFieldDecorator}
                            rules={[...ValidationUtility.required('Security Question 1 is required')]}
                            name="question1"
                            label="Security Question 1">
                            <SimpleSelect options={this.state.questions} />


                        </FormControl>

                        <FormControl
                            getFieldDecorator={getFieldDecorator}
                            name="answer1"
                            label="Answer">
                            <Input />
                        </FormControl>

                        <FormControl
                            getFieldDecorator={getFieldDecorator}
                            rules={[...ValidationUtility.required('Security Question 2 is required')]}
                            name="question2"
                            label="Security Question 2">
                            <SimpleSelect options={this.state.questions} />
                        </FormControl>

                        <FormControl
                            getFieldDecorator={getFieldDecorator}
                            name="answer2"
                            label="Answer">
                            <Input />
                        </FormControl>

                        <FormControl
                            getFieldDecorator={getFieldDecorator}
                            rules={[...ValidationUtility.required('Security Question 3 is required')]}
                            name="question3"
                            label="Security Question 3">
                            <SimpleSelect options={this.state.questions} />

                        </FormControl>

                        <FormControl
                            getFieldDecorator={getFieldDecorator}
                            name="answer3"
                            label="Answer">
                            <Input />
                        </FormControl>

                        <FormItem>
                            <Row>
                                <Col>
                                    <Button htmlType="submit">Update</Button>
                                </Col>
                            </Row>
                        </FormItem>
                    </Form>
                </Col>
            </Row>
        );
    }
}

const UpdateSecurityQuestionFormWithoutRouter = Form.create<Props>({
    name: 'UpdateSecurityQuestionForm',
})(UpdateSecurityQuestionFormWithoutFormsAndRouter);

const UpdateSecurityQuestionForm = withRouter(UpdateSecurityQuestionFormWithoutRouter);

export default UpdateSecurityQuestionForm;
